import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }

import { computed } from "vue";
import HierarchyTagItem from "shared/components/other/HierarchyTagItem.vue";
import { HierarchyType } from "shared/types/HierarchyTag";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationTag',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const tags = computed(() =>
  Object.entries(props.data).map(([type, name]) => ({
    type: type as HierarchyType,
    name,
  })),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: tag }, [
        (tag.name)
          ? (_openBlock(), _createBlock(HierarchyTagItem, {
              key: 0,
              class: "m-1 cursor-pointer align-middle text-xs",
              tag: tag
            }, null, 8, ["tag"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})